import { logout } from "../../features/user/userSlice";
import { authAPI } from "../auth/auth";

export const userAPI = {
    async getUser() {
        let resp = await fetch(`/api/user/`)
            .catch(err => {
                console.log(err);
            }
        );

        if (resp.status === 401) {
            let authorized = await authAPI.refreshToken();
            if (authorized) {
                return this.getUser();
            }
            return {unauthorized: true}
        }

        let body = await resp.json();
        if(!body) {
            return {ok: false, err: "something_went_wrong"}
        }

        if(body.ok && body.user) {
            return {ok: true, user: body.user}
        }

        if(body.err) {
            return {ok: false, err: "something_went_wrong"}
        }

        return {ok: false, err: "something_went_wrong"}
    },
    async updateUser(data) {
        let resp = await fetch(`/api/user/`, {
            method: "PUT",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(data)
        }).catch(err => {
            console.log(err);
        });

        if (resp.status === 401) {
            let authorized = await authAPI.refreshToken();
            if (authorized) {
                return this.updateUser(data);
            }
            return {unauthorized: true}
        }

        let body = await resp.json();
        if(!body) {
            return {ok: false, err: "something_went_wrong"}
        }

        if(body.ok && body.user) {
            return {ok: true, user: body.user}
        }

        if(body.err) {
            return {ok: false, err: "something_went_wrong"}
        }

        return {ok: false, err: "something_went_wrong"}
    },
    async logout() {
        let resp = await fetch(`/api/logout`, {
            method: "POST"
        }).catch(err => {
            console.log(err);
        })

        let body = await resp.json();
        if(!body) {
            return {ok: false, err: "something_went_wrong"}
        }

        if(body.ok) {
            return {ok: true}
        }

        return {ok: false, err: "something_went_wrong"}
    }
}